import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import { useEffect, useRef, useState } from "react";
import { Overlay, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  getAcumaticaHerbById,
  getDiseaseClassification,
  getFormulaById,
  getHerbByFormulaId,
  getHerbById,
  getModificationById,
  getSubclassById,
} from "../../actions/formulaAction";
import { ERROR } from "../../constants/types/alertType";

const SearchByDiseaseList = ({
  isRawType,
  closePopup,
  includeDosage,
  setIncludeDosage,
}) => {
  const diseaseList = useSelector((state) => state.formula.present.diseaseList);
  const patternList = useSelector(
    (state) => state.formula.present.subclassByIdList
  );
  const formulaList = useSelector(
    (state) => state.formula.present.formulaByIdList
  );
  const modificationList = useSelector(
    (state) => state.formula.present.modificationByIdList
  );
  const formulas = useSelector((state) => state.formula.present.formulaSection);
  const [selectedDisease, setSelectedDisease] = useState(null);
  const [selectedPattern, setselectedPattern] = useState(null);
  const [selectedFormula, setSelectedFormula] = useState(null);
  const [selectedModification, setSelectedModification] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dosage, setDosage] = useState();
  const target = useRef(null);
  const selectRef = useRef(null);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDiseaseClassification());
    if (selectRef.current) {
      selectRef.current.focus();
    }
  }, [dispatch]);

  const optionRenderer = ({ label }, { inputValue }) => {
    const matches = match(label, inputValue);
    const parts = parse(label, matches);
    return (
      <div>
        {parts.map((part, index) => (
          <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
            {part.text}
          </span>
        ))}
      </div>
    );
  };

  return (
    <div>
      <p className="page-desc">
        Find Formulas and Mods based on the Disease and Pattern.
      </p>
      {!isRawType && (
        <div className="row align-items-center mb-4 justify-content-between">
          {/* <div className="col-md-5">
            <div className="radio-item">
              <label
                className="container"
                onClick={() => setIncludeDosage(true)}
              >
                Include Suggested Dosages
                <input type="radio" checked={includeDosage} name="existing" />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className="radio-item">
              <label
                className="container"
                onClick={() => setIncludeDosage(false)}
              >
                Do Not Include Suggested Dosages
                <input type="radio" name="new" checked={!includeDosage} />
                <span className="checkmark"></span>
              </label>
            </div>
          </div> */}
          {includeDosage && (
            <>
              <div className="col-md-4 text-right">
                Total amount (grams) of this formula:
              </div>

              <div className=" d-flex justify-content-end">
                <input
                  ref={target}
                  disabled={!includeDosage}
                  type="number"
                  step=".5"
                  min={0}
                  style={{ width: "auto", marginRight: "20px" }}
                  placeholder="enter your dosage"
                  className={`gram-input formula ${
                    dosage == null || isNaN(dosage) ? "red-border" : ""
                  }`}
                  value={dosage}
                  onChange={(e) => {
                    e.target.value >= 0
                      ? setDosage(parseFloat(e.target.value))
                      : setDosage(null);
                  }}
                />
                <Overlay
                  target={target.current}
                  show={dosage == null || isNaN(dosage) || dosage <= 0}
                  placement="top"
                >
                  {(props) => (
                    <Tooltip id="overlay-example" {...props}>
                      You must enter a dosage
                    </Tooltip>
                  )}
                </Overlay>
              </div>
            </>
          )}
        </div>
      )}
      <div className="row">
        <div className="col-md-2">
          <h5 className="cat-title">Disease:</h5>
        </div>
        <div className="col-md-10">
          <Select
            ref={selectRef}
            onChange={(e) => {
              setLoading(true);
              dispatch(
                getSubclassById(e.value, () => {
                  setLoading(false);
                })
              );
              setSelectedDisease(e.value);
              setselectedPattern(null);
              setSelectedFormula(null);
              setSelectedModification(null);
            }}
            placeholder="Select A Disease"
            value={
              selectedDisease
                ? {
                    label: diseaseList.find((x) => x.DC_ID == selectedDisease)
                      ?.DC_Display,
                  }
                : ""
            }
            options={diseaseList.map((x) => ({
              value: x.DC_ID,
              label: x.DC_Display,
            }))}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (props, { isDisabled }) => ({
                ...props,
                cursor: isDisabled ? "not-allowed" : "pointer",
                pointerEvents: "auto",
              }),
            }}
            menuPortalTarget={document.body}
            menuPlacement={"bottom"}
            menuShouldScrollIntoView={false}
            formatOptionLabel={optionRenderer}
          ></Select>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-2">
          <h5 className="cat-title">Pattern:</h5>
        </div>
        <div className="col-md-10">
          <Select
            onChange={(e) => {
              setLoading(true);
              dispatch(
                getFormulaById(selectedDisease, e.value, () => {
                  setLoading(false);
                })
              );
              setselectedPattern(e.value);
              setSelectedFormula(null);
              setSelectedModification(null);
            }}
            value={
              selectedPattern
                ? {
                    label: patternList.find((x) => x.DSC_ID == selectedPattern)
                      ?.DSC_Display,
                  }
                : ""
            }
            isDisabled={!selectedDisease || loading}
            placeholder="Select A Pattern"
            options={patternList.map((x) => ({
              value: x.DSC_ID,
              label: x.DSC_Display,
            }))}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (props, { isDisabled }) => ({
                ...props,
                cursor: isDisabled ? "not-allowed" : "pointer",
                pointerEvents: "auto",
              }),
            }}
            menuPortalTarget={document.body}
            menuPlacement={"bottom"}
            menuShouldScrollIntoView={false}
            formatOptionLabel={optionRenderer}
          ></Select>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-2">
          <h5 className="cat-title">Formula:</h5>
        </div>
        <div className="col-md-10">
          <Select
            onChange={(e) => {
              setLoading(true);
              dispatch(
                getModificationById(
                  selectedDisease,
                  selectedPattern,
                  e.value,
                  () => {
                    setLoading(false);
                  }
                )
              );
              setSelectedFormula(formulaList.find((x) => x.FORM_ID == e.value));
              setSelectedModification(null);
            }}
            value={
              selectedFormula
                ? {
                    label: selectedFormula?.FORM_Display,
                  }
                : ""
            }
            placeholder="Select A Formula"
            isDisabled={!selectedPattern || loading}
            options={formulaList.map((x) => ({
              value: x.FORM_ID,
              label: x.FORM_Display,
            }))}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (props, { isDisabled }) => ({
                ...props,
                cursor: isDisabled ? "not-allowed" : "pointer",
                pointerEvents: "auto",
              }),
            }}
            menuPortalTarget={document.body}
            menuPlacement={"bottom"}
            menuShouldScrollIntoView={false}
            formatOptionLabel={optionRenderer}
          ></Select>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-2">
          <h5 className="cat-title">Mod:</h5>
        </div>
        <div className="col-md-10">
          <Select
            onChange={(e) => {
              setSelectedModification(
                modificationList.find((x) => x.MOD_ID == e.value)
              );
            }}
            isDisabled={!selectedFormula || loading}
            value={
              selectedModification
                ? {
                    label: selectedModification?.MOD_Display,
                  }
                : ""
            }
            placeholder="You May Choose A Modification"
            options={modificationList.map((x) => ({
              value: x.MOD_ID,
              label: x.MOD_Display,
            }))}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (props, { isDisabled }) => ({
                ...props,
                cursor: isDisabled ? "not-allowed" : "pointer",
                pointerEvents: "auto",
              }),
            }}
            menuPortalTarget={document.body}
            menuPlacement={"bottom"}
            menuShouldScrollIntoView={false}
            formatOptionLabel={optionRenderer}
          ></Select>
        </div>
      </div>
      <div
        className={`row mt-2 d-flex ${
          isRawType ? "justify-content-end" : "justify-content-between"
        } align-items-center`}
      ></div>
      <div className="d-flex justify-content-end">
        <button
          style={{ marginRight: "20px" }}
          disabled={
            !selectedFormula ||
            (includeDosage && (dosage <= 0 || isNaN(dosage)) && !isRawType)
          }
          className="btn-orange"
          onClick={() => {
            if (formulas.some((x) => x.formulaId === selectedFormula.FORM_ID)) {
              dispatch({
                type: ERROR,
                payload: "Selected Formula is already in the list",
              });
            } else if (selectedFormula.FORM_Creator_ID == 2) {
              dispatch(getAcumaticaHerbById(selectedFormula.FORM_ID));
            } else {
              dispatch(
                getHerbByFormulaId(
                  selectedFormula.FORM_ID,
                  selectedFormula.FORM_Display,
                  () => {
                    if (selectedModification) {
                      dispatch(
                        getHerbById(
                          selectedDisease,
                          selectedPattern,
                          selectedFormula.FORM_ID,
                          selectedModification.MOD_ID,
                          selectedModification.MOD_Display,
                          includeDosage
                        )
                      );
                    }
                  },
                  includeDosage ? dosage : 0.001
                )
              );
            }
            closePopup();
          }}
        >
          Add Formula
        </button>
      </div>
    </div>
  );
};
export default SearchByDiseaseList;
